module.exports = __webpack_public_path__ + "assets/media/lunch.b7ef6cb8.mp3";